import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface ActivityItem {
  id: string;
  action: string;
  caseRef: string;
  time: string;
  icon: string;
  iconColor: string;
}

interface ActivityFeedProps {
  activities: ActivityItem[];
}

const ActivityFeed = ({ activities }: ActivityFeedProps) => {
  return (
    <div className="bg-card rounded-lg border border-border shadow-elevation-1">
      <div className="px-4 py-3 border-b border-border flex items-center justify-between">
        <h3 className="text-sm font-heading font-600 text-text-primary">Recent Activity</h3>
        <Icon name="ClockIcon" size={16} variant="outline" className="text-text-secondary" />
      </div>
      <div className="divide-y divide-border">
        {activities.map((item) => (
          <div key={item.id} className="px-4 py-3 flex items-start gap-3 hover:bg-muted/40 transition-standard">
            <div className={`flex items-center justify-center w-7 h-7 rounded-full flex-shrink-0 mt-0.5 ${item.iconColor}`}>
              <Icon name={item.icon as any} size={13} variant="solid" className="text-white" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm text-text-primary leading-snug">{item.action}</p>
              <div className="flex items-center gap-2 mt-0.5">
                <span className="font-data text-xs text-primary">{item.caseRef}</span>
                <span className="text-xs font-caption text-text-secondary">{item.time}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ActivityFeed;
export type { ActivityItem };